function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import COPY from './getFooterCopy';
import { getHelpCenterLink } from '../../../..';
import { showBoardOfDirectorsLink, showNewsRoom, showDachPaymentLinks, showImprintLink, showBlog } from '../../../../helpers/languageHelpers';
export var getSlimLinks = function getSlimLinks(lang) {
  return [{
    title: t(COPY.ABOUT_SURVEYMONKEY),
    url: createURL('/mp/aboutus/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.PRIVACY_NOTICE),
    url: createURL('/mp/legal/privacy/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
    url: createURL('/mp/legal/region-specific-privacy-statement/', {
      ut_source: 'footer'
    }),
    anchorAttributes: {
      rel: 'nofollow'
    }
  }].concat(_toConsumableArray(lang === 'de' ? [{
    title: 'Impressum',
    url: createURL('/mp/impressum/', {
      ut_source: 'footer'
    })
  }] : []), [{
    title: t(COPY.EMAIL_OPT_IN),
    url: createURL('/user/email-opt-in/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.OFFICE_LOCATIONS),
    url: createURL('/mp/aboutus/office-locations/', {
      ut_source: 'footer'
    }),
    lastItem: true
  }]);
};
export var getCommunityLinks = function getCommunityLinks(domain, lang) {
  return [{
    title: t(COPY.COMMUNITY),
    url: 'https://www.facebook.com/surveymonkey/',
    isTitle: true
  }].concat(_toConsumableArray(showBlog(lang) ? [{
    title: t(COPY.OUR_BLOG),
    url: createURL('/curiosity/', {
      ut_source: 'footer'
    })
  }] : []), [{
    title: 'Facebook',
    url: 'https://www.facebook.com/surveymonkey/'
  }, {
    title: 'Twitter',
    url: 'https://twitter.com/SurveyMonkey'
  }, {
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/company/surveymonkey/'
  }, {
    title: 'Instagram',
    url: 'https://www.instagram.com/surveymonkey/'
  }, {
    title: 'YouTube',
    url: 'https://www.youtube.com/surveymonkey'
  }, {
    title: t(COPY.DEVELOPERS),
    url: createURL("https://developer.".concat(domain, ".com"), {
      ut_source: 'footer'
    }),
    lastItem: true
  }]);
};
export var getAboutUsLinks = function getAboutUsLinks(domain, lang, country) {
  return [{
    title: t(COPY.ABOUT_US),
    url: createURL('/mp/aboutus/', {
      ut_source: 'footer'
    }),
    isTitle: true
  }, {
    title: t(COPY.LEADERSHIP_TEAM),
    url: createURL('/mp/aboutus/leadership/', {
      ut_source: 'footer'
    })
  }].concat(_toConsumableArray(showBoardOfDirectorsLink(lang) ? [{
    title: t(COPY.BOARD_OF_DIRECTORS),
    url: createURL('/mp/aboutus/directors/', {
      ut_source: 'footer'
    })
  }] : []), _toConsumableArray(showNewsRoom(lang, country) ? [{
    title: t(COPY.INVESTOR_RELATIONS),
    url: 'https://investor.surveymonkey.com/'
  }] : []), [{
    title: t(COPY.APP_DIRECTORY),
    url: createURL('/apps/', {
      ut_source: 'footer'
    })
  }], _toConsumableArray(showNewsRoom(lang, country) ? [{
    title: t(COPY.NEWSROOM),
    url: createURL('/newsroom/', {
      ut_source: 'footer'
    })
  }] : []), [{
    title: t(COPY.OFFICE_LOCATIONS),
    url: createURL('/mp/aboutus/office-locations/', {
      ut_source: 'footer'
    })
  }], _toConsumableArray(showDachPaymentLinks(lang, country) ? [{
    title: 'Impressum',
    url: createURL('/mp/impressum/', {
      ut_source: 'footer'
    })
  }] : []), _toConsumableArray(showDachPaymentLinks(lang, country) ? [{
    title: t(COPY.PAYMENT_METHODS),
    url: getHelpCenterLink(lang, {
      path: 'billing/payment-methods',
      params: {
        ut_source: 'footer'
      }
    })
  }] : []), _toConsumableArray(showImprintLink(lang, country) ? [{
    title: t(COPY.IMPRINT),
    url: createURL("www.".concat(domain, "/mp/imprint"), {
      ut_source: 'footer'
    })
  }] : []), [{
    title: t(COPY.CAREERS),
    url: createURL('/careers/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.SITEMAP),
    url: createURL('/mp/sitemap/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.HELP),
    url: getHelpCenterLink(lang, {
      params: {
        ut_source: 'footer'
      }
    }),
    lastItem: true
  }]);
};
export var getPolicesLink = function getPolicesLink(lang) {
  return [{
    title: t(COPY.POLICIES),
    url: createURL('/mp/legal/', {
      ut_source: 'footer'
    }),
    isTitle: true
  }, {
    title: t(COPY.TERMS_OF_USE),
    url: createURL('/mp/legal/terms-of-use/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.PRIVACY_NOTICE),
    url: createURL('/mp/legal/privacy/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
    url: createURL('/mp/legal/region-specific-privacy-statement/', {
      ut_source: 'footer'
    }),
    anchorAttributes: {
      rel: 'nofollow'
    }
  }, {
    title: t(COPY.ACCEPTABLE_USES_POLICY),
    url: createURL('/mp/legal/acceptable-uses-policy/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.SECURITY_STATEMENT),
    url: createURL('/mp/legal/security/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.GDPR_COMPLIANCE),
    url: createURL('/mp/privacy/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.EMAIL_OPT_IN),
    url: createURL('/user/email-opt-in/', {
      ut_source: 'footer'
    })
  }, {
    title: t(COPY.ACCESSIBILITY),
    url: getHelpCenterLink(lang, {
      path: 'create/accessibility',
      params: {
        ut_source: 'footer'
      }
    })
  }, {
    title: t(COPY.COOKIES_NOTICE),
    url: createURL('/mp/legal/cookies/', {
      ut_source: 'footer'
    })
  }];
};
export var getAnonCategories = function getAnonCategories() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var variant = arguments.length > 3 ? arguments[3] : undefined;
  var defaultLinks = [getCommunityLinks(domain, lang), getAboutUsLinks(domain, lang, country), getPolicesLink(lang)];
  var slimLinks = [getSlimLinks(lang)];
  return variant === 'default' ? defaultLinks : slimLinks;
};
//# sourceMappingURL=getAnonFooterLinks.js.map